/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/account";
class AccountService {

    
    async isValid(password) {
        try {
            return await http.post(`${controller}/validate`, {password});
        }catch(err) {
            throw new Error("Error validating user password");
        }
        
    }
    async accountinfo() {
        const response = await http.get(`${controller}/accountinfo`);
        const data = response;
        return data;
    } 

    updateuserinfo(orgId, data) {
        return http.put(`${controller}/updateuserinfo?parentAccountId=${orgId}`, data);
    }

    async uploadaccountimage(file) {
        const response = await http.post(`${controller}/uploadaccountimage/`, file);
        const data = response;
        return data;
    }

    async get(id, getUsers = true) {
        const response = await http.get(`${controller}?organizationId=${id}&getUsers=${getUsers}`);
        const data = response;
        return data;
    }

    async getpartnerinfo(id, justUsers = false) {
        const response = await http.get(`${controller}/getpartnerinfo?organizationId=${id}&justUsers=${justUsers}`);
        const data = response;
        return data;
    }
    

    async uploadimage(file) {
        const response = await http.post(`${controller}/uploadimage/`, file);
        const data = response;
        return data;
    }

    async deletehvac(id) {
        const response = await http.delete(`${controller}/deletehvac?organizationId=${id}`)
        const data = response;
        return data;
    }

    invite(data) {
        return http.post(`${controller}/invite`, data);
    }

    inviteusers(name, id, users) {
        return http.post(`${controller}/inviteusers?orgName=${name}&orgId=${id}`, users);
    }

    inviteusersloop(name, id, users) {
        return http.post(`${controller}/inviteusersloop?orgName=${name}&orgId=${id}`, users);
    }

    disable(username, userId, orgId) {
        return http.post(`${controller}/disable?username=${encodeURIComponent(username)}&userId=${userId}&organizationId=${orgId}`);
    }
    
    disableBulk(orgId, users) {
        return http.post(`${controller}/disableBulk?organizationId=${orgId}`, users);
    }
  
    disablelifewhereuser(username, userId) {
        return http.post(`${controller}/disablelifewhereuser?username=${encodeURIComponent(username)}&userId=${userId}`);
    }

    updateorg(data) {
        return http.put(`${controller}/updateorg`, data);
    }

    updateuser(parentAccountId, data) {
        return http.post(`${controller}/updateuser?parentAccountId=${parentAccountId}`, data)
    }

    updatelifewhereuser(data) {
        return http.post(`${controller}/updatelifewhereuser`, data)
    }

    update(data) {
        return http.put(`${controller}/updatecustomeraccount`, data);
    }

    delete(id) {
        return http.delete(`${controller}?organizationId=${id}`);
    }

    deletesystem(id) {
        return http.delete(`${controller}/deletesystem?hvacAssetId=${id}`);
    }

    softDeleteAccount(partnerOrgId, customerOrgId) {
        return http.delete(`${controller}/movetodeletedorg?partnerOrgId=${partnerOrgId}&customerOrgId=${customerOrgId}`)
    }

    recoverAccount(partnerOrgId, customerOrgId) {
        return http.post(`${controller}/recoverAccount?partnerOrgId=${partnerOrgId}&customerOrgId=${customerOrgId}`)
    }

    recoverhomes(customerOrgId) {
        return http.post(`${controller}/recoverhomes?customerOrgId=${customerOrgId}`)
    }

    recoverSystem(assetId, houseAssetId, customerOrgId) {
        return http.post(`${controller}/recoversystem?assetId=${assetId}&houseAssetId=${houseAssetId}&customerOrgId=${customerOrgId}`)
    }

    deleteaccountassets(id) {
        return http.delete(`${controller}/accountassets?organizationId=${id}`);
    }

    deleteuser(orgId, userId) {
        return http.delete(`${controller}/deleteuser?organizationId=${orgId}&userId=${userId}`);
    }
    async logon() {
        const response = http.post(`${controller}/logon`);
        const data = await response;
        return data;
    }

    partnerdeletedaccounts(partnerOrgId) {
        return http.get(`${controller}/partnerdeletedaccounts?partnerOrgId=${partnerOrgId}`);
    }

    partnerdeletedsystems(partnerOrgId) {
        return http.get(`${controller}/partnerdeletedsystems?partnerOrgId=${partnerOrgId}`)
    }

    getRolesList(orgId) {
        return http.get(`${controller}/getroleslist?orgId=${orgId}`);
    }
}

export default new AccountService();